import {all, spawn, call} from 'redux-saga/effects';

import {orderLineSaga} from 'sagas/order-line.saga';
import {orderTimeSaga} from 'sagas/order-time.saga';
import {customerSaga} from 'sagas/customer.saga';
import {apiSaga} from 'sagas/api.saga';
import {purchaseSaga} from 'sagas/purchase.saga';
import {navigationSaga} from 'sagas/navigation.saga';
import {popupSaga} from 'sagas/popup.saga';
import {connectivitySaga} from 'sagas/connectivity.saga';
import {authKeeperSaga} from 'sagas/auth-keeper.saga';
import {customerUpdaterSaga} from 'sagas/customer-updater.saga';
import {restaurantListUpdaterSaga} from 'sagas/restaurant-list-updater.saga';
import {menuUpdaterSaga} from 'sagas/menu-updater.saga';
import {restaurantUpdaterSaga} from 'sagas/restaurant-updater.saga';
import {serverConfigUpdaterSaga} from 'sagas/server-config-updater.saga';
import {orderTimeUpdaterSaga} from 'sagas/order-time-updater.saga';
import {localizationUpdaterSaga} from 'sagas/localization-updater.saga';
import {clientLogSaga} from 'sagas/client-log.saga';
import {permissionSaga} from 'sagas/permission.saga';
import {geolocationSaga} from 'sagas/geolocation.saga';
import {manifestLoaderSaga} from './manifest-loader.saga';
import {pwaSaga} from 'sagas/pwa.saga';
import {clientLogSenderSaga} from "./client-log-sender.saga";
import {linkSaga} from "./link.saga";
import {paymentSaga} from "./payment.saga";

export const rootSaga = function* rootSaga() {
	const sagas = [
		orderLineSaga,
		orderTimeSaga,
		customerSaga,
		apiSaga,
		purchaseSaga,
		navigationSaga,
		popupSaga,
		connectivitySaga,
		authKeeperSaga,
		customerUpdaterSaga,
		restaurantListUpdaterSaga,
		menuUpdaterSaga,
		restaurantUpdaterSaga,
		serverConfigUpdaterSaga,
		orderTimeUpdaterSaga,
		localizationUpdaterSaga,
		clientLogSaga,
		permissionSaga,
		geolocationSaga,
		manifestLoaderSaga,
		pwaSaga,
		// Temporarily disable
		///clientLogSenderSaga,
		linkSaga,
		paymentSaga
	];

	yield all(sagas.map(saga =>
		spawn(function* () {
			while (true) {
				try {
					yield call(saga)
					break
				} catch (e) {
					console.log(e)
				}
			}
		}))
	);
};
